import React from "react";

const EntertainmentCard = () => {
  return <div>EntertainmentCard</div>;
};

export default EntertainmentCard;
